import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React from 'react';
import classNames from 'classnames';
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";

export const RolePage = () => {

    const [todo, setTodo] = React.useState('');
    const [id, setId] = React.useState('');
    const [name, setName] = React.useState('');
    const [submitted, setSubmitted]  = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    
    const toast = React.useRef();    
    const location = useLocation();
    let history = useHistory();

    React.useEffect(function() {
        setTodo(location.state.todo);
        if(location.state.todo === 'Ubah') {
            setId(location.state.dataRole.id);
            setName(location.state.dataRole.name);
        }       
    }, [location])

    const showSuccess = (message) => {
        toast.current.show({ severity: 'success', summary: 'Berhasil', detail: message, life: 3000 });
    };

    const showFailed = (message) => {
        toast.current.show({ severity: 'error', summary: 'Gagal', detail: message, life: 3000 });
    };

    const showError = (message) => {
        toast.current.show({ severity: 'error', summary: 'Kesalahan', detail: message, life: 3000 });
    };

    async function clickSubmit(event) {
        event.preventDefault();
        setSubmitted(true);
        if(!name) {
            showError('Form role tidak boleh ada yang kosong!');
        } else {
            const requestPayload =  {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*' ,
                    'Authorization': 'Bearer ' +localStorage.getItem('jwt')
                },
                body: JSON.stringify({
                    id: todo === 'Tambah' ? null : id,
                    name: name
                })
            }
            setIsLoading(true);
            const response = await fetch('https://springboot-widy-app.widyan123.site/widy-app/role/add-edit/'+todo, requestPayload);
            const res = await response.json();
            if(response.status >= 200 && response.status <= 299) {                
                showSuccess(res.message);
                setTimeout(() => {
                    history.push('/roles');
                }, 2000)
            } else if(response.status >= 400 && response.status <= 499) {
                if(response.status === 401) {
                    history.push('/login');
                } else {
                    showFailed(res.message);
                }                
            } else {
                showError(res.message);
            }
            setIsLoading(false);
        }        
    }

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">                    
                <Toast ref={toast} />
                    <h5>{todo} Role</h5>
                    <p>Use this page to start from scratch and place your custom content.</p>
                </div>
                <div className='card p-fluid'>
                    
                    <form onSubmit={clickSubmit}>
                        <div className="field">
                            <label htmlFor="name">Name</label>
                            <InputText id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} className={classNames({ 'p-invalid': submitted && !name })} />
                            {submitted && !name && <small className="p-error">Enter your name</small>}
                        </div>
                        <Button label="Submit" className="p-button-success mr-2" loading={isLoading} />
                    </form>
                </div>  
            </div>
        </div>
    );
}
